import { createUseStyles } from 'react-jss';
import { Classes } from 'jss';
import { grayPalette } from '@tcl-argon-colors/colors';

export const useCollapseStyles: (
  data?: { isOpen?: boolean } & {
    theme?: Jss.Theme;
  },
) => Classes<'title' | 'content' | 'root' | 'titleWrapper' | 'toggle' | 'openToggle' | 'closeToggle'> = createUseStyles(
  {
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 'inherit',
      overflow: 'hidden',
    },
    titleWrapper: {
      marginBottom: ({ isOpen }) => {
        return isOpen ? '24px' : '0px';
      },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      cursor: 'pointer',
      transition: 'margin-bottom 75ms cubic-bezier(0, 0, .58, 1)',
    },
    toggle: {
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      paddingRight: '0px',
      paddingLeft: '0px',
      marginRight: '24px',
    },
    openToggle: {
      transform: 'rotate(-180deg)',
      transition: 'transform 150ms cubic-bezier(0, 0, .58, 1)',
    },
    closeToggle: {
      transform: 'rotate(0deg)',
      transition: 'transform 150ms cubic-bezier(0, 0, .58, 1)',
    },
    contentWrapper: {
      overflowY: 'scroll',
      flexGrow: 1,
      paddingRight: '8px',
      '@supports not selector(::-webkit-scrollbar)': {
        scrollbarWidth: 'thin',
        scrollbarColor: `${grayPalette.gray45} transparent`,
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '16px',
        background: `${grayPalette.gray45}`,
        border: '6px solid rgba(0, 0, 0, 0)',
        backgroundClip: 'padding-box',
      },
      '&::-webkit-scrollbar': {
        border: 'none',
        width: '16px',
      },
      '&::-webkit-scrollbar-button': {
        width: '0',
        height: '0',
        display: 'none',
      },
      '&::-webkit-scrollbar-corner': {
        backgroundColor: 'transparent',
      },
    },
    content: {
      transition: 'max-height 150ms cubic-bezier(0, 0, .58, 1)',
      transitionDelay: ({ isOpen }) => {
        return isOpen ? '0s' : '-75ms';
      },
    },
    title: {
      fontSize: '20px',
      lineHeight: '20px',
      fontWeight: 'bold',
    },
  },
);
